<script>
import { setCookie, getCookie } from '../utils/cookie.js'

export default {
   methods: {
      promptInstall() {
         window.promptWindowInstall()
      },
      buttonDownload() {
         if (window.buttonDownloadDo) {
            window.buttonDownloadDo()
         } else {
            // console.log('There is no window.buttonDownloadDo()');
         }
      },
   },
};
</script>

<template>
   <span>
      <button id="pwa_button_preinstall" class="button button_big button_main">
         &nbsp;<div class="loader_parent"><span class="loader loader_loaging"></span></div>
      </button>
      <button id="pwa_button_download" class="button button_big button_main" @click="buttonDownload"
         style="display: none;">
         {{ $t('buttons.download') }}
      </button>
      <div id="pwa_double_buttons" style="display: none;">
         <button id="pwa_double_left_button" class="button button_double_big button_main">
            {{ $t('buttons.cancel') }}
         </button>
         <button id="pwa_double_right_button" class="button button_double_big button_main">
            {{ $t('buttons.open') }}
         </button>
      </div>
      <button id="pwa_button_install" class="button button_big button_main" @click="promptInstall"
         style="display: none;">
         {{ $t('buttons.install') }}
      </button>
      <button id="pwa_button_go_to_app" class="button button_big button_main" style="display: none;">
         {{ $t('buttons.open') }}
      </button>
   </span>
</template>


<style>
.button_big {
   width: calc(100vw - 52px);
   padding: 10px 0;
   border-radius: 20px;
   max-width: 620px;
}
</style>